import { inject, injectable } from "@launchtray/tsyringe-async";
import { IRemoveBuildingController } from "./IRemoveBuildingController";
import { IRemoveBuildingModel } from "../models/IRemoveBuildingModel";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { AsyncOperationNotification } from "by/gamefactory/cityversetycoon/scenes/common/components/AsyncOperationNotification";
import { IPlayerModel } from "by/gamefactory/cityversetycoon/scenes/common/models/IPlayerModel";
import { Web3Model } from "by/gamefactory/web3/models/Web3Model";

@injectable()
export class RemoveBuildingController implements IRemoveBuildingController {
    private readonly web3Model: Web3Model;
    private readonly removeBuildingModel: IRemoveBuildingModel;
    private readonly playerModel: IPlayerModel;
    private readonly asyncOperationNotification: AsyncOperationNotification;
    private readonly logger: ILogger;
    
    public constructor(
        web3Model: Web3Model,
        @inject("IRemoveBuildingModel") removeBuildingModel: IRemoveBuildingModel,
        @inject("IPlayerModel") playerModel: IPlayerModel,
        asyncOperationNotification: AsyncOperationNotification,
        @inject("ILogger") logger: ILogger
    ) {
        this.web3Model = web3Model;
        this.removeBuildingModel = removeBuildingModel;
        this.playerModel = playerModel;
        this.asyncOperationNotification = asyncOperationNotification;
        this.logger = logger;
    }

    public async removeBuildingFromMarketplace(mpBuildingId: string, orderId: string): Promise<boolean> {
        let result = false;
        try {
            this.asyncOperationNotification.show();
            result = await this.removeBuildingModel.removeBuildingFromMarketplace(mpBuildingId);
            await this.web3Model.removeFromReservoir(orderId);
            await this.playerModel.loadBuildings();
            return result;
        } catch (error: unknown) {
            this.logger.error(error);
            return result;
        }
        finally {
            this.asyncOperationNotification.hide();
        }
    }
}